import classnames from "classnames";
import React from "react";

import { getDamPath } from "@utils/configuration/aem";
import { EmptyImages, ProductImageRenditions } from "@utils/enums";

import { Image } from "@components/Product/ProductImage/imageWrapper/image/image.component";

import { Media } from "lib/@types/service/shared";

import "./imageWrapper.scss";

type Props = {
    title: string | undefined;
    medias: null | Array<Media>;
    isEcoChequesAccepted: boolean;
    rendition?: ProductImageRenditions;
    className?: string;
    lazyLoad?: boolean;
    parentFit?: boolean;
};

const ProductImage = ({
    title,
    medias,
    isEcoChequesAccepted,
    rendition,
    className,
    lazyLoad = false,
    parentFit = false,
}: Props) => {
    return (
        <div className={classnames("productImage-wrapper")}>
            {isEcoChequesAccepted && (
                <div className="productImage-wrapper__eco-label">
                    <img
                        className="productImage-wrapper__label"
                        src={`${getDamPath()}/site-afbeeldingen/eco.svg`}
                        alt="ecocheques"
                    />
                </div>
            )}
            {medias && (
                <Image
                    className={classnames(
                        "productImage-wrapper__image",
                        className,
                    )}
                    medias={medias}
                    altText={title}
                    defaultImageUrl={EmptyImages.Size_146_109}
                    rendition={rendition}
                    lazyLoad={lazyLoad}
                    parentFit={parentFit}
                />
            )}
        </div>
    );
};

export { ProductImage };
